import { RegionShared } from "@1games-ru/region-shared";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import VehicleMpProvider from "@/core/data-provider/data-mp/vehicle/vehicle-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { QueryKey } from "@/domains/transportWarehouse/constants/queryKey";
import toast from "@/domains/toasts/helpers/toast";

export default function useClearLot() {
  const queryClient = useQueryClient();
  const [isClearingLot, setClearingLot] = useState(false);

  const clearLot = useCallback(
    async (data: typeof RegionShared.Backend.Requests.GarageClearLotRequest) => {
      setClearingLot(true);
      const response = await VehicleMpProvider.clearLotGarage(data);
      if (response instanceof RpcMpProviderFailedResponse) {
        toast.error(response.error);
      } else {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: [QueryKey.VehiclesRelated] }),
          queryClient.invalidateQueries({ queryKey: [QueryKey.TransportWarehouseInfo] }),
        ]);
      }
      setClearingLot(false);
    },
    [queryClient],
  );

  return {
    isClearingLot,
    clearLot,
  };
}
